export const setScopes = (scopes) => ({
    type: "SET_SCOPES",
    payload: scopes,
  });
export const setRoles = (roles) => ({
    type: "SET_ROLES",
    payload: roles,
  });
  export const setAllRoles = (roles) => ({
    type: "SET_ALL_ROLES",
    payload: roles,
  });
  export const setScopesNames = (setScopesNames) => ({
    type: "SET_SCOPES_NAMES",
    payload: setScopesNames,
  });
  export const setPermissions = (permissions) => ({
    type: "SET_PERMISSIONS",
    payload: permissions,
  });